/**
 * Survey Frequency Configuration
 *
 * These constants control how often surveys are displayed to users.
 * All values are easily configurable and can be adjusted as needed.
 */

/** Number of days in the rolling window for tool and IPP-wide limits */
export const SURVEY_WINDOW_DAYS = 180

/** Maximum number of surveys that can be shown across all IPP tools within the window */
export const MAX_IPP_SURVEYS_COUNT = 10

/** Cooldown period (in days) after any survey interaction (submit or dismiss) */
export const INTERACTION_COOLDOWN_DAYS = 1

/** LocalStorage key for survey frequency data */
export const SURVEY_FREQUENCY_STORAGE_KEY = 'ipp_survey_frequency_data'

// Derived constants (in milliseconds for easier comparison)
export const SURVEY_WINDOW_MS = SURVEY_WINDOW_DAYS * 24 * 60 * 60 * 1000
export const INTERACTION_COOLDOWN_MS = INTERACTION_COOLDOWN_DAYS * 24 * 60 * 60 * 1000
